import axios from 'axios';
import { config } from 'config';
import jwtDecode from 'jwt-decode';
const items = [
  {
    href: '/main/home',
    router: true,
    title: 'Home',
    icon: 'home',
    service: 'home',
    isShow: true,
  },
  {
    href: '/main/badges',
    router: true,
    title: 'Badges',
    icon: 'bookmark',
    service: 'badges',
    isShow: false,
  },
  {
    href: '/main/badgeTypes',
    router: true,
    title: 'BadgeTypes',
    icon: 'map',
    service: 'badge-types',
    isShow: false,
  },
  {
    href: '/main/badwords',
    router: true,
    title: 'BadWords',
    icon: 'comment',
    service: 'bad-words',
    isShow: false,
  },
  {
    href: '/main/commonReasons',
    router: true,
    title: 'CommonReasons',
    icon: 'list',
    service: 'common-reasons',
    isShow: false,
  },
  {
    href: '/main/deletedMessages',
    router: true,
    title: 'DeletedMessages',
    icon: 'message',
    service: 'deleted-messages',
    isShow: false,
  },
  {
    href: '/main/followersSettings',
    router: true,
    title: 'FollowersSettings',
    icon: 'star',
    service: 'badge-rules',
    isShow: false,
  },
  {
    href: '/main/loadtest',
    router: true,
    title: 'loadtest',
    icon: 'settings',
    service: 'loadtest',
  },
  {
    href: '/main/messageIncidents',
    router: true,
    title: 'MessageIncidents',
    icon: 'message',
    service: 'message-incidents',
    isShow: false,
  },
  {
    href: '/main/products',
    router: true,
    title: 'Products',
    icon: 'shop',
    service: 'products',
    isShow: false,
  },
  {
    href: '/main/reportedMessage',
    router: true,
    title: 'ReportedMessages',
    icon: 'report',
    service: 'reported-messages',
    isShow: false,
  },
  {
    href: '/main/review',
    router: true,
    title: 'Reviews',
    icon: 'list',
    service: 'uri-reviews',
    isShow: false,
  },
  {
    href: '/main/roleBadgeRelations',
    router: true,
    title: 'RoleBadgesAssignments',
    icon: 'assignment',
    service: 'role-badge-relations',
    isShow: false,
  },
  {
    href: '/main/rooms',
    router: true,
    title: 'Rooms',
    icon: 'featured_video',
    service: 'rooms',
    isShow: false,
  },
  {
    href: '/main/settings',
    router: true,
    title: 'Settings',
    icon: 'settings',
    service: 'settings',
    isShow: false,
  },
  {
    href: '/main/streamVendors',
    router: true,
    title: 'StreamVendors',
    icon: 'people',
    service: 'stream-vendors',
    isShow: false,
  },
  {
    href: '/main/tickets',
    router: true,
    title: 'Tickets',
    icon: 'message',
    service: 'tickets',
    isShow: false,
  },
  {
    href: '/main/users',
    router: true,
    title: 'Users',
    icon: 'people',
    service: 'users',
    isShow: false,
  },
];
const apiUrl = config().server.api;
export const fetchData = (params: string, authorization: string) => {
  const headers = {
    authorization: 'Bearer ' + authorization,
  };
  return axios
    .get(`${apiUrl}/${params}`, { headers })
    .then((res) => {
      return res.data;
    });
};
const getData = async (authorization: string) => {
  try {
    const sessionResult = await fetchData('v2/admin/user/session', authorization);
    const iamResult = await fetchData('v2/admin/iam', authorization);
    const isAdmin =
      iamResult.iams.find((iam: any) =>
        ['Role:Hermes:SuperAdmin', 'Role:Hermes:Admin'].includes(iam)
      ) != null;
    if (!isAdmin) {
      throw new Error('You have no right to login in admin!');
    }
    const { user, token } = sessionResult.metadata;
    const exp = (jwtDecode(token) as any).exp;
    const menus = items.map((item) => item.title).filter((e) => e !== 'home');
    return {
      expiredAt: exp,
      user,
      menus,
    };
  } catch (error: any) {
    let errorMsg = error.message;
    if (errorMsg != null && (error.response || {}).status !== 403) {
      return null;
    } else {
      window.alert('Login failed, please check email and password!');
    }
  }
};
export default getData;